<template>
  <v-snackbar v-model="snackbar">
    {{ snackbarText }}
    <v-btn text color="primary" @click.native="snackbar = false">Close</v-btn>
  </v-snackbar>
</template>

<script>
export default {
  setup() {},
  data() {
    return {
      snackbar: false,
      snackbarText: ''
    }
  },
  methods: {
    activate(message) {
      this.snackbar = true
      this.snackbarText = message
    }
  }
}
</script>
